export default __webpack_public_path__ + "static/media/mon_24.cce2ce20.png";